var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4073c77fe3d953a3d4bc10d1545bb7961d9b02d0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["goals-wizard@success-wizard"]={id:"4073c77fe3d953a3d4bc10d1545bb7961d9b02d0"};
      